import { useEffect, useState } from "react";
import { fetchPageContent } from "../api/contentApi";
import { useNavigate } from "react-router-dom";
import { useLang } from "../context/LangContext";
import "../styles/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faFacebook, faXTwitter, faSquareLinkedin } from "@fortawesome/free-brands-svg-icons";

export default function Footer() {
const [content, setContent] = useState({});
  const { lang } = useLang();

  const navigate = useNavigate();

  useEffect(() => {
    fetchPageContent("contact", lang).then(data => setContent(data));
  }, [lang]);

  if (!content) return <p>Loading...</p>;

   const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer">
      <div className="footer-main">

  <div className="footer-logo-section">
    <img
      src="/logo.png"
      alt="Logo"
      className="footer-logo"
      onClick={() => navigate("/")}
    />
  </div>

  <div className="footer-company-section">
    <h2>{content.name}</h2>

    <div className="footer-address">
      <p>{content.address_title}</p>
      <p>{content.address}</p>
    </div>

    <div className="footer-hours">
      <p>{content.open_title}</p>
      <p>{content.open}</p>
    </div>
  </div>

</div>

<div className="footer-contact">

  {content.phone && (
    <a href={`tel:+${content.phone}`}>
      <FontAwesomeIcon icon={faPhone} />
      +{content.phone}
    </a>
  )}

  {content.email && (
    <a href={`mailto:${content.email}`}>
      <FontAwesomeIcon icon={faEnvelope} />
      {content.email}
    </a>
  )}
    {content.email_1 && (
    <a href={`mailto:${content.email_1}`}>
      <FontAwesomeIcon icon={faEnvelope} />
      {content.email_1}
    </a>
  )}

            {/* Socialmedia */}
            
              <div className="footer-socials">
              {content.instagram_link && (
                <a href={content.instagram_link} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              )}

              {content.facebook_link && (
                <a href={content.facebook_link} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              )}

              {content.x_link && (
                <a href={content.x_link} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
              )}

              {content.linkedin_link && (
                <a href={content.linkedin_link} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faSquareLinkedin} />
                </a>
              )}
            </div>
           
      
      </div>
     

      {/* Bottom Copyright */}
      <div className="footer-bottom">
    © {currentYear} {content.name}. All rights reserved. 
</div>
    </footer>
  );
}